<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="farmForm" ref="farmForm" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category3" prop="category3Code">
                <el-select v-model="farmForm.category3Code" disabled style="width:100%">
                  <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Farm" prop="farmName">
                <el-input v-model="farmForm.farmName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Farm Group" prop="farmGroup">
                <el-input v-model="farmForm.farmGroup" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="farmGroupStatus">
                <el-select v-model="farmForm.farmGroupStatus" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="small" class="btn" type="primary" @click="onSel">选择</el-button>
      </el-row>
      <el-table ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="600" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="Category3" show-overflow-tooltip prop="category3Name"></el-table-column>
        <el-table-column align="center" label="Sponsor" show-overflow-tooltip prop="sponsorName"></el-table-column>
        <el-table-column align="center" label="Farm" show-overflow-tooltip prop="farmName"></el-table-column>
        <el-table-column align="center" label="Farm Group" show-overflow-tooltip prop="farmGroup"></el-table-column>
        <el-table-column align="center" label="状态" show-overflow-tooltip prop="farmGroupStatus"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="farmForm.pageNum" :page-sizes="pageSizeList" :page-size="farmForm.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import rmcProdPurchaseApi from "@/api/rmcProduce/purchase";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: '',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      multipleSelection: [],
      idList: [],
      category3CodeOptions: [],
      ownershipOptions: [],
      domesticOrOverseas: [],
      tableData: [],
      ms_Permission: [],
      statusList: [],
      farmForm: {
        pageSize: 15,
        pageNum: 1,
        category3Code: "",
        farmName: "",
        farmGroupStatus: "",
        farmGroup: "",
      },
      isShow: false,
      dialogVisible: false,
      totalCount: 0,
      pages: 1,
    }
  },
  created() {
    this.getSelection()
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
  },
  methods: {
    queryData() {
      if (this.category3CodeOptions.length === 1) {
        this.$set(this.farmForm, 'category3Code', this.category3CodeOptions[0].key)
      }
      rmcProdPurchaseApi.findFarmList(this.farmForm).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    getSelection() {
      rmcProdPurchaseApi.getSelection(['rmc.RmcCategory3','rmc.RmcProteinAslStatus']).then(res => {
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'produce'
        })
        this.statusList=res.data['rmc.RmcProteinAslStatus']
        this.queryData()
      });
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.idList = []
      val.forEach(ele => {
        this.idList.push(ele.rmcProduceFarmId)
      })
    },
    onSel() {
      this.$emit('setFarm', JSON.stringify(this.multipleSelection))
    },
    onSearch() {
      this.farmForm.pageNum = 1
      this.farmForm.pageSize = 15
      this.queryData()
    },
    handleSizeChange(val) {
      this.farmForm.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.farmForm.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['farmForm'].resetFields()
      this.farmForm = {
        pageSize: 15,
        pageNum: 1,
        category3Code: "",
        farmName: "",
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
